<p class="value ges ges_{{ favorite.ges }}">
    <b>{{ favorite.ges }}</b>
    <span class="text-black" *ngIf="favorite.ges == ''">-</span>
    <span *ngIf="favorite.ges_value">({{ favorite.ges_value }})</span>
</p>
<i class="fa fa-info-circle" *ngIf="favorite.ges_value || favorite.ges" (click)="popup()"></i>
